import type {
  BlockObjectResponse,
  RichTextItemResponse,
} from '@notionhq/client/build/src/api-endpoints'

export interface BlockPayload {
  rich_text?: RichTextItemResponse[]
  /**
   * Notion never nests children in its responses; `getBlockTree` grafts them on
   * so a renderer can walk the tree in one pass.
   */
  children?: BlockObjectResponse[]
}

/**
 * A block's own payload — `block.paragraph`, `block.image`, and so on. TS can't
 * index a discriminated union by its own discriminant, so the single cast that
 * makes `block[block.type]` legal lives here rather than at every call site.
 */
export function blockPayload(block: BlockObjectResponse): BlockPayload {
  return (block as unknown as Record<string, BlockPayload>)[block.type] ?? {}
}

export function blockChildren(
  block: BlockObjectResponse,
): BlockObjectResponse[] {
  return blockPayload(block).children ?? []
}

export function blockRichText(
  block: BlockObjectResponse,
): RichTextItemResponse[] {
  return blockPayload(block).rich_text ?? []
}
